import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingOverlayService } from '../../services/loading-overlay.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class LoadingOverlayComponent {
  loadingService = inject(LoadingOverlayService);
}
